import { Grid2 } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import CitiesAutocomplete from "../components/CitiesAutocomplete";

export default function ManageCities({ control, watch }) {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const city = watch("city");
  const API_ENDPOINT = process.env.REACT_APP_API_URL;
  // Fetch cities based on search query
  useEffect(() => {
    const fetchCities = async () => {
      if (!query) {
        setCities([]);
        return;
      } // Skip fetching if the query is empty
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_ENDPOINT}/api/cities?query=${query}`
        );
        setCities(
          response.data.slice(0, 10).map((city) => ({
            id: city.id,
            label: city.name, // Assuming API returns `name` for the city
          }))
        );
      } catch (error) {
        console.error("Error fetching cities:", error);
      } finally {
        setLoading(false);
      }
    };

    // Debounce the API call
    const timeoutId = setTimeout(fetchCities, 400); // Adjust debounce time as needed
    return () => clearTimeout(timeoutId);
  }, [query]);

  useEffect(() => {
    if (city && !query) {
      setCities([city]);
    }
  }, [city, query]);
  return (
    <Grid2 size={{ xs: 12, lg: 6 }}>
      <CitiesAutocomplete
        control={control}
        fieldname="city"
        options={cities}
        label="City"
        required
        loading={loading}
        onSearch={setQuery} // Pass the query setter
        query={query}
      />
    </Grid2>
  );
}
